require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bujagali-will-the-world-bank-miss-the-opportunity-to-learn-from-its-mistakes.json") })
        }
      }, "path---en-us-update-bujagali-will-the-world-bank-miss-the-opportunity-to-learn-from-its-mistakes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bujagali-will-the-world-bank-miss-the-opportunity-to-learn-from-its-mistakes!./.cache/json/en-us-update-bujagali-will-the-world-bank-miss-the-opportunity-to-learn-from-its-mistakes.json
// module id = 633
// module chunks = 231608221292675